const getSupplier = (state) => state.productSuppliers.supplier;

export default getSupplier;
